import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'next-i18next';
import { Divider, LabelXSmall, Stack } from '../../../primitives/index.js';
export const SectionDivider = () => {
  const {
    t
  } = useTranslation('authentication');
  return _jsxs(Stack, {
    direction: "row",
    spacing: "small",
    alignItems: "center",
    children: [_jsx(Divider, {}), _jsx(LabelXSmall, {
      children: t('signIn.other')
    }), _jsx(Divider, {})]
  });
};